const API_HOST = "https://dev.api.app.bbsperanta.ro";

export default Object.freeze({
    API_HOST,
    REQ_TOKEN: API_HOST + "/login_check",
    REFRESH_TOKEN: API_HOST + "/token/refresh",
    REGISTER: API_HOST + "/register"
});


// WEBPACK FOOTER //
// ./src/store/modules/links/links.js